import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import React from "react";
import NewBenefit from "./Benefits/NewBenefits";
import FAQSection from "./faq/faq";
import NewHero from "./hero/NewHero";
import NewLandingPageServices from "./serviceSection/NewLandingPageServices";
import NewTestimonial from "./Testimonial/NewTestimonial";

const LandingPage: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash === "#services") {
      const section = document.getElementById("services");
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);
  return (
    <>
      <NewHero />
      <div id="services">
        <NewLandingPageServices />
      </div>
      <NewBenefit />
      <NewTestimonial />
      <FAQSection />
    </>
  );
};

export default LandingPage;
